const t = {
  name: "SolutionPlatformEngineering",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,12l-6.1,6L6,12l6-6L18,12z M15.2,12L12,8.8L8.8,12l3.1,3.2L15.2,12z"/>
		<path class="st0" d="M12,24l12-12L12,0L0,12L12,24z M12,2.8l9.2,9.2L12,21.2L2.8,12L12,2.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as SolutionPlatformEngineering
};
